{
  "componentTypeProductionValues": [],
  "componentTypeManualProductionValues": [],
  "productIndividual": {},
  "Paging": {
    "offset": 100,
    "page": 1
  }
}